import anime from 'animejs';

export default ( data, step, direction ) => {
  const duration = 1000;
  const min = 0;
  const max = 110;
  const from = step === 'leave' ? min : max;
  const to = step === 'leave' ? max : min;

  const targets = step === 'leave' ? data.current.container : data.next.container;
  const translateX = direction === 'next' ? `-${ to }%` : `${ to }%`;

  targets.style.transform = direction === 'next'
    ? `translateX(${ from }%)`
    : `translateX(-${ from }%)`;

  if ( step === 'enter' ) {
    targets.style.marginTop = `${ window.pageYOffset }px`;;
  }

  const staggerX = window.innerWidth * 0.1;
  const anim = anime.timeline( {
    easing: 'easeInOutQuart',
    duration,
  } );

  anim.add( {
    targets,
    translateX,
  } );


  if ( step === 'enter' ) {
    anim.add( {
      targets: targets.querySelectorAll( 'main > *' ),
      // translateX: direction === 'next' ? [ staggerX, 0 ] : [ -staggerX, 0 ],
      translateX: direction === 'next' ? [ staggerX, 0 ] : [ -staggerX, 0 ],
      duration: duration * 0.6,
      easing: 'easeOutQuart',
      delay: anime.stagger( 100 ),
    }, '-=500' );
  }

  return anim.finished;
}
